// src/pages/Admin/RoleComponents/RoleFilters.jsx
import React from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterBox from "../../../../components/common/FilterBox"; // Adjust path as needed
import ClearIcon from "@mui/icons-material/Clear";

const RoleFilters = ({
  roleNameFilter,
  descriptionFilter,
  handleRoleNameFilterChange,
  handleDescriptionFilterChange,
  handleClearFilters, // Assuming you have a clear filters handler
  handleCreateRoleClick,
}) => {
  // Define the structure of the filter form
  const filterForm = [
    {
      name: "roleNameFilter",
      type: "text",
      placeholder: "Search by Role Name",
      value: roleNameFilter,
    },
    {
      name: "descriptionFilter",
      type: "text",
      placeholder: "Search by Description",
      value: descriptionFilter,
    },
  ];

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}
    >
      {" "}
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
        <FilterBox
          filterForm={filterForm}
          onFilterChange={(e, index) => {
            if (index === 0) handleRoleNameFilterChange(e);
            if (index === 1) handleDescriptionFilterChange(e);
          }}
          onFilterSubmit={(e) => e.preventDefault()} // Prevents form submission on enter key
          className="flex flex-start gap10" // Adjust class names as needed
          buttonValue="" // Hide the default 'SEARCH' button
        />
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleCreateRoleClick}
        size="small"
        sx={{
          height: 40,
          backgroundColor: "#ED141F",
          "&:hover": {
            backgroundColor: "#ED141F",
          },
        }}
      >
        Create Role
      </Button>
    </Box>
  );
};

export default RoleFilters;
